import React from "react";
import { txtA, txtE } from "../../../../Label/Lbl";
import Grid from "@material-ui/core/Grid";
import { useInvAF, useInvMain } from "../../../../St/Reviews/UseStyle";
import { colors } from "@material-ui/core";
export function getcolor(text) {
    try {
        const obj = JSON.parse(text);
        for (let key in obj) {
            if (typeof obj[key] === "string" && obj[key].match(/^#[0-9A-Fa-f]{3,6}$/)) {
                return obj[key];
            }
        }
    } catch {
        return "#f5ebdb";
    }
};
const UnderHeaderCom = (props) => {
    const { found, inv, sta, locInv } = props;
    const clasm = useInvMain();
    const clas = useInvAF();
    const styfC = { fontWeight: "500", color:locInv?.largeNum === 24 ? "#000" : "#9a3f47" };
    const styfCenter = { fontWeight: "bold", maxHeight: "1rem", minHeight: "1rem", color: "#000" };
    const styLeft = { textAlign: "left", paddingLeft: "0.5rem", maxLines: 1, backgroundColor: colors.grey[200] };
    const styRight = { textAlign: "right", paddingRight: "0.5rem", maxLines: 1, backgroundColor: colors.grey[200] };
    const isPurchase = locInv.ProcTypeInvProc === "02" || locInv.ProcTypeInvProc === "12" ||
        locInv.ProcTypeInvProc === "03" ? false : true;

    return (
        <Grid
            item
            container
            className={clas.Bdyroot}
            style={{ fontWeight: "bold", fontFamily: "Amiri-Regular", marginLeft: "0cm", marginRight: "0rem", paddingTop: "0.5rem" }}
        >
            <Grid item xs={12}>
                <Grid item container style={{ direction: "rtl" }}>
                    <Grid item xs={6} style={{ fontFamily: "Amiri-Regular", paddingTop: "0.3rem", border: "solid 0.1px", }}
                    >
                        <Grid item container className={clasm.mincntr}>
                            <Grid item xs={12}
                                container
                                style={{
                                    backgroundColor: colors.grey[200],
                                    paddingTop: "0.3rem",
                                }}>
                                <Grid item xs={6} style={{ textAlign: "right", paddingRight: "0.5rem" }}>
                                    {isPurchase ? txtA.cusNM : "العميل"}
                                </Grid>

                                <Grid item xs={6} style={{ textAlign: "left", paddingLeft: "0.5rem" }}>
                                    {isPurchase ? "Supplier" : "Customer"}
                                </Grid>

                            </Grid>
                            <Grid item xs={12} ></Grid>
                            <Grid item xs={2} style={styRight}> {isPurchase ? txtA.cusNM : "العميل"}</Grid>
                            <Grid item xs={8} style={styfC}>
                                <div style={styfCenter}>{sta.tot.cust_name}</div>
                            </Grid>
                            <Grid item xs={2} style={styLeft}>
                                {"Name"}
                            </Grid>
                            <Grid item xs={3} style={styRight}>
                                {"رقم المبنى"}

                            </Grid>
                            <Grid item xs={6} style={styfC}>
                                <div style={styfCenter}>{sta.tot.tax_no_build_cust}</div>
                            </Grid>
                            <Grid item xs={3} style={styLeft}>
                                {"Build No"}
                            </Grid>
                            <Grid item xs={3} style={styRight}>
                                {"اسم الشارع"}
                            </Grid>
                            <Grid item xs={6} style={styfC}>
                                <div style={styfCenter}>{sta.tot.tax_name_street_cust}</div>
                            </Grid>
                            <Grid item xs={3} style={styLeft}>
                                {"Street Name"}
                            </Grid>

                            <Grid item xs={3} style={styRight}>
                                {"الحي"}
                            </Grid>
                            <Grid item xs={6} style={styfC}>
                                <div style={styfCenter}>{sta.tot.tax_name_district_cust}</div>
                            </Grid>
                            <Grid item xs={3} style={styLeft}>
                                {"District"}
                            </Grid>

                            <Grid item xs={3} style={styRight}>
                                {"المدينة"}
                            </Grid>
                            <Grid item xs={6} style={styfC}>
                                <div style={styfCenter}>{sta.tot.tax_name_city_cust}</div>
                            </Grid>
                            <Grid item xs={3} style={styLeft}>
                                {"City"}
                            </Grid>

                            <Grid item xs={3} style={styRight}>
                                {"البلد"}
                            </Grid>
                            <Grid item xs={6} style={styfC}>
                                <div style={styfCenter}>{sta.tot.tax_name_country_cust}</div>
                            </Grid>
                            <Grid item xs={3} style={styLeft}>
                                {"Country"}
                            </Grid>
                            <Grid item xs={3} style={styRight}>
                                {"الرمز البريدي"}
                            </Grid>
                            <Grid item xs={6} style={styfC}>
                                <div style={styfCenter}>{sta.tot?.tax_zip_code_cust}</div>
                            </Grid>
                            <Grid item xs={3} style={styLeft}>
                                {"Postal Code"}
                            </Grid>

                            <Grid item xs={3} style={styRight}>
                                {"الرقم الاضافي"}
                            </Grid>
                            <Grid item xs={6} style={styfC}>
                                <div style={styfCenter}>{sta.tot?.tax_additional_address_no_cust}</div>
                            </Grid>
                            <Grid item xs={3} style={styLeft}>
                                {"Additional No"}
                            </Grid>

                            <Grid item xs={3} style={styRight}>
                                {txtA.taxNumr}
                            </Grid>
                            <Grid item xs={6} style={styfC}>
                                <div style={styfCenter}>{sta.tot.tax_no_cust}</div>
                            </Grid>
                            <Grid item xs={3} style={styLeft}>
                                {txtE.taxNumr}
                            </Grid>
                            <Grid item xs={3} style={styRight}>
                                {"رقم السجل"}
                            </Grid>
                            <Grid item xs={6} style={styfC}>
                                <div style={styfCenter}>{sta.tot?.tax_vat_registration_no_cust}</div>
                            </Grid>
                            <Grid item xs={3} style={styLeft}>
                                {"C R No"}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6} style={{ fontFamily: "Amiri-Regular", paddingTop: "0.3rem", border: "solid 0.1px", }}

                    >
                        <Grid item container className={clasm.mincntr}>
                            <Grid item xs={12} container style={{
                                backgroundColor: colors.grey[200],
                                paddingTop: "0.3rem",
                            }}>
                                <Grid item xs={6} style={{ textAlign: "right", paddingRight: "0.5rem" }}>
                                    {isPurchase ? "العميل" : txtA.cusNM}
                                </Grid>

                                <Grid item xs={6} style={{ textAlign: "left", paddingLeft: "0.5rem" }}>
                                    {isPurchase ? "Customer" : "Supplier"}

                                </Grid>

                            </Grid>
                            <Grid item xs={2} style={styRight}>
                                {isPurchase ? "Customer" : "Supplier"}
                            </Grid>
                            <Grid item xs={8} >
                                <div style={styfCenter}>{found.Disc1_header_ar}</div>
                            </Grid>
                            <Grid item xs={2} style={styLeft}>
                                {"Name"}
                            </Grid>
                            <Grid item xs={3} style={styRight}>
                                {"رقم المبنى"}
                            </Grid>
                            <Grid item xs={6} style={styfC}>
                                <div style={styfCenter}>{sta.tot.tax_no_build_found}</div>
                            </Grid>
                            <Grid item xs={3} style={styLeft}>
                                {"Build No"}
                            </Grid>
                            <Grid item xs={3} style={styRight}>
                                {"اسم الشارع"}
                            </Grid>
                            <Grid item xs={6} style={styfC}>
                                <div style={styfCenter}>{sta.tot.tax_name_street_found}</div>
                            </Grid>
                            <Grid item xs={3} style={styLeft}>
                                {"Street Name"}
                            </Grid>
                            <Grid item xs={3} style={styRight}>
                                {"الحي"}
                            </Grid>
                            <Grid item xs={6} style={styfC}>
                                <div style={styfCenter}>{sta.tot.tax_name_district_found}</div>
                            </Grid>
                            <Grid item xs={3} style={styLeft}>
                                {"District"}
                            </Grid>

                            <Grid item xs={3} style={styRight}>
                                {"المدينة"}

                            </Grid>
                            <Grid item xs={6} style={styfC}>
                                <div style={styfCenter}>{sta.tot.tax_name_city_found}</div>
                            </Grid>
                            <Grid item xs={3} style={styLeft}>
                                {"City"}

                            </Grid>

                            <Grid item xs={3} style={styRight}>
                                {"البلد"}

                            </Grid>
                            <Grid item xs={6} style={styfC}>
                                <div style={styfCenter}>{sta.tot.tax_name_country_found}</div>
                            </Grid>
                            <Grid item xs={3} style={styLeft}>
                                {"Country"}
                            </Grid>
                            <Grid item xs={3} style={styRight}>
                                {"الرمز البريدي"}

                            </Grid>
                            <Grid item xs={6} style={styfC}>
                                <div style={styfCenter}>{sta.tot.tax_zip_code_found}</div>
                            </Grid>
                            <Grid item xs={3} style={styLeft}>
                                {"Postal Code"}

                            </Grid>

                            <Grid item xs={3} style={styRight}>
                                {"الرقم الاضافي"}

                            </Grid>
                            <Grid item xs={6} style={styfC}>
                                <div style={styfCenter}>{sta.tot.tax_additional_address_no_found}</div>
                            </Grid>
                            <Grid item xs={3} style={styLeft}>
                                {"Additional No"}
                            </Grid>

                            <Grid item xs={3} style={styRight}>
                                {txtA.taxNumr}
                            </Grid>
                            <Grid item xs={6} style={styfC}>
                                <div style={styfCenter}>{sta.tot.tax_vat_registration_no_found}</div>
                            </Grid>
                            <Grid item xs={3} style={styLeft}>
                                {txtE.taxNumr}
                            </Grid>
                            <Grid item xs={3} style={styRight}>
                                {"رقم السجل"}
                            </Grid>
                            <Grid item xs={6} style={styfC}>
                                <div style={styfCenter}>{sta.tot?.foundaion_bsn_no}</div>
                            </Grid>
                            <Grid item xs={3} style={styLeft}>
                                {"C R No"}
                            </Grid>
                        </Grid>
                    </Grid>
                    {locInv?.largeNum !== 30 &&
                        (
                            <Grid container item xs={12} style={{ paddingTop: "0.3rem" }}>
                                <Grid container item xs={10} style={styRight}>
                                    <Grid
                                        item
                                        container
                                        xs={12}
                                        style={{
                                            whiteSpace: 'pre-wrap',
                                            overflowWrap: 'break-word',
                                            fontWeight: "bold",
                                            direction: "rtl",
                                            fontFamily: "Amiri-Regular",
                                            textAlign: "right"
                                        }}
                                    >
                                        {inv?.notes}
                                    </Grid>
                                </Grid>
                                <Grid container item xs={2} style={{ direction: "ltr", fontWeight: "bold" }}>
                                    {"Desscription / "}{"البيان"}
                                </Grid>

                            </Grid>
                        )}

                </Grid>
            </Grid>

        </Grid>
    );
};

export default UnderHeaderCom;
